import * as React from 'react';
import {
	PopupBox,
	ModalBox,
	EventHeader,
	EventTitle,
	EventInfo,
	EventButton,
} from './EventStyled';
import { Button } from '@mui/material';

const PopupCard = () => {
	return (
		<PopupBox>
			<ModalBox>
				{/* <CloseMark>&#215;</CloseMark> */}
				<EventHeader>
					<EventTitle>The Flutter Talk w/ Debasmita Sarkar</EventTitle>
					<EventInfo>Sun, Mar 6, 6:00 PM (IST)</EventInfo>
				</EventHeader>
				<EventTitle>About this event</EventTitle>
				<EventInfo>
					<br />
					Fasten your seatbelts as we prepare to take off on our Flutter Flight
					<br />
					<br />
					Wanna know about Flutter from an industry professional?
					<br />
					<br />
					We have just the event for you!
					<br />
					<br />
					Flutter Festival | The Flutter Talk w/ Debasmita Sarkar
					<br />
					<br />
					Join Debasmita Sarkar | Flutter Developer and SDE2 at Uni Cards this
					Sunday as we go over an introduction to Flutter.
					<br />
					<br />
					🗓️ Date- 06/03/2022
					<br />
					<br />
					⏰ Time- 6pm
					<br />
					<br />
					You can share any questions you want to ask Ms Debasmita about the
					technology in the event itself or go over to GDSC Kalindi’s discord
					and share them in #flutter.
					<br />
					<br />
					Discord- https://discord.gg/T2SsvcmBMK
					<br />
					<br />
					Hope to see you there!
				</EventInfo>
				<EventButton>
					<Button variant='contained' href='#contained-buttons'>
						More Details
						<svg width='15px' height='10px' viewBox='0 0 13 10'>
							<path d='M1,5 L11,5'></path>
							<polyline points='8 1 12 5 8 9'></polyline>
						</svg>
					</Button>
				</EventButton>
			</ModalBox>
		</PopupBox>
	);
};

export default PopupCard;
